import { PageId } from 'constants/pages'

export const enum PageIdIntl2Lw {
  ANALYZING = PageId.ANALYZING_INTL_2LW,
  INTRO_CERTIFICATE = PageId.INTRO_CERTIFICATE_INTL_2LW,
  START = PageId.START_INTL_2LW,
  QUESTION_1 = PageId.QUESTION_1_INTL_2LW,
  QUESTION_2 = PageId.QUESTION_2_INTL_2LW,
  QUESTION_3 = PageId.QUESTION_3_INTL_2LW,
  QUESTION_4 = PageId.QUESTION_4_INTL_2LW,
  SPEED_FEEDBACK = PageId.SPEED_FEEDBACK_INTL_2LW,
  QUESTION_5 = PageId.QUESTION_5_INTL_2LW,
  QUESTION_6 = PageId.QUESTION_6_INTL_2LW,
  QUESTION_7 = PageId.QUESTION_7_INTL_2LW,
  QUESTION_8 = PageId.QUESTION_8_INTL_2LW,
  QUESTION_9 = PageId.QUESTION_9_INTL_2LW,
  QUESTION_10 = PageId.QUESTION_10_INTL_2LW,
  QUESTION_11 = PageId.QUESTION_11_INTL_2LW,
  QUESTION_12 = PageId.QUESTION_12_INTL_2LW,
  SMARTNESS_FEEDBACK = PageId.SMARTNESS_FEEDBACK_INTL_2LW,
  QUESTION_13 = PageId.QUESTION_13_INTL_2LW,
  QUESTION_14 = PageId.QUESTION_14_INTL_2LW,
  QUESTION_15 = PageId.QUESTION_15_INTL_2LW,
  QUESTION_16 = PageId.QUESTION_16_INTL_2LW,
  QUESTION_17 = PageId.QUESTION_17_INTL_2LW,
  QUESTION_18 = PageId.QUESTION_18_INTL_2LW,
  QUESTION_19 = PageId.QUESTION_19_INTL_2LW,
  QUESTION_20 = PageId.QUESTION_20_INTL_2LW,
  LOGICAL_SKILLS_FEEDBACK = PageId.LOGICAL_SKILLS_FEEDBACK_INTL_2LW,
  QUESTION_21 = PageId.QUESTION_21_INTL_2LW,
  QUESTION_22 = PageId.QUESTION_22_INTL_2LW,
  QUESTION_23 = PageId.QUESTION_23_INTL_2LW,
  QUESTION_24 = PageId.QUESTION_24_INTL_2LW,
  QUESTION_25 = PageId.QUESTION_25_INTL_2LW,
  AGE_QUESTION = PageId.AGE_QUESTION_INTL_2LW,
  EDUCATION_QUESTION = PageId.EDUCATION_QUESTION_INTL_2LW,
  DISCOVER_FEEDBACKS = PageId.DISCOVER_FEEDBACKS_INTL_2LW,
  PREPARE_FLOW = PageId.PREPARE_FLOW_INTL_2LW,
  EMAIL = PageId.EMAIL_INTL_2LW,
  EMAIL_CONSENT = PageId.EMAIL_CONSENT_INTL_2LW,
  OFFER = PageId.OFFER_INTL_2LW,
  SPECIAL_DISCOUNT = PageId.SPECIAL_DISCOUNT_INTL_2LW,
  CANCEL_OFFER = PageId.CANCEL_OFFER_INTL_2LW,
  PAYMENT = PageId.PAYMENT_INTL_2LW,
  CHECKOUT = PageId.CHECKOUT_INTL_2LW,
  UPSELL = PageId.UPSELL_INTL_2LW,
  REGISTRATION = PageId.REGISTRATION_INTL_2LW,
  NAME_ENTRY = PageId.NAME_ENTRY_INTL_2LW,
  CERTIFICATE = PageId.CERTIFICATE_INTL_2LW,
  LEARNWORLDS_REDIRECT = PageId.LEARNWORLDS_REDIRECT_INTL_2LW,
  REPORT = PageId.REPORT_INTL_2LW,
}
